import { render, staticRenderFns } from "./ProjectReadOnlyBudgetView.vue?vue&type=template&id=15b6d268&scoped=true&"
import script from "./ProjectReadOnlyBudgetView.vue?vue&type=script&lang=js&"
export * from "./ProjectReadOnlyBudgetView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b6d268",
  null
  
)

export default component.exports